import { Badge, merge } from '@repo/ui'

export function BetaBadge({ className }: { className?: string }) {
  return (
    <Badge
      className={merge('absolute right-2 top-2 mr-auto w-auto text-xs sm:text-xs', className)}
      colour='red'
    >
      Beta
    </Badge>
  )
}
